import { countries } from "../const/countries";
const { culture, regionId = 1 } = window;

function localizer({default: strings},resolver){
	return resolver( str => strings[str] || str );
}

export function localize(){
	return new Promise((resolve)=>{
		let langCall = undefined;
		switch(culture || 'en-us'){
			case 'en-us':
				langCall = parseInt(regionId) === 6 ? import('./langs/en-SUPERT.js') : import('./langs/en-US.js');
				break;
			case 'es-mx':
				langCall = import('./langs/es-MX.js');
				break;
			case 'es-cl':
				langCall = import('./langs/es-CL.js');
				break;
			case 'es-co':
				langCall = import('./langs/es-CO.js');
				break;
			case 'es-pe':
				langCall = import('./langs/es-PE.js');
		}
		langCall ? 
			langCall.then( strings => localizer(strings,resolve) ) :
			resolve( str => str );
	});
};

export function localToggles(key){
	return (({
		'1': {
			'MCUSDOT': true
		},
		'7': {
			'MCUSDOT': true
		}
	})[regionId] || {})[key] || false;
}

export function localCountries(emptyForNone){
	let limit;
	switch(regionId){
		case '3':
		case '4': 
		case '5': 
			limit = ['CL','CO','CR','PA','PE'];
			break;
		default:
			limit = [];
	}
	return 	limit.length ? countries.filter(({code}) => limit.indexOf(code) !== -1) :
			emptyForNone ? [] : 
			countries;
}